import CalendarIcon from 'assets/icons/calendar.svg?react';
import FAQIcon from 'assets/icons/faq.svg?react';
import IdeaIcon from 'assets/icons/idea.svg?react';
import SlackIcon from 'assets/icons/slack.svg?react';
import { COMPANY_FORM_ID, TALENT_FORM_ID } from 'components/typeform/hooks';
import { useCurrentUser } from 'hooks/auth';
import { useIsFreeCompanyAccount } from 'hooks/company/useCompanyAccountType';
import { useIsUsCompany } from 'hooks/company/useCompanyRegion';
import { useIsUsCurrentTalent } from 'hooks/talents/useCurrentTalentRegion';

import LiveHelpOutlinedIcon from '@mui/icons-material/LiveHelpOutlined';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

import { BottomDrawerListItemProps } from './types';

export const useBottomDrawerItems = (): BottomDrawerListItemProps[] => {
  const { isTalent } = useCurrentUser();
  const useItems = isTalent
    ? useTalentBottomDrawerItems
    : useCompanyBottomDrawerItems;
  const items = useItems();

  return items;
};

const useTalentBottomDrawerItems = (): BottomDrawerListItemProps[] => {
  const isUsCurrentTalent = useIsUsCurrentTalent();
  const items: BottomDrawerListItemProps[] = [];

  // items.push({
  //   text: 'Refer a Client 💰',
  //   href: 'https://form.typeform.com/to/IsXp4ljT',
  //   disabled: isNotVerifiedTalent,
  //   htmlTitle: isNotVerifiedTalent ? DRAWER_ITEM_LOBBY_TEXT : '',
  //   Icon: CampaignIcon,
  // });

  items.push({
    text: "What's Next?",
    href: 'https://form.typeform.com/to/cPnNdBVH',
    Icon: IdeaIcon,
    // disabled: isNotVerifiedTalent,
    // htmlTitle: isNotVerifiedTalent ? DRAWER_ITEM_LOBBY_TEXT : '',
  });

  if (!isUsCurrentTalent) {
    items.push({
      text: "We're on Slack",
      href: 'https://join.slack.com/t/opentalentcommunity/shared_invite/zt-wgcocyxg-63qpP96wR5biBAF5GGmlOw',
      // disabled: isNotVerifiedTalent,
      // htmlTitle: isNotVerifiedTalent ? DRAWER_ITEM_LOBBY_TEXT : '',
      Icon: SlackIcon,
    });
  }
  items.push({
    text: 'Give Feedback',
    // disabled: isNotVerifiedTalent,
    // htmlTitle: isNotVerifiedTalent ? DRAWER_ITEM_LOBBY_TEXT : '',
    href: `https://form.typeform.com/to/${TALENT_FORM_ID}`,
    Icon: LiveHelpOutlinedIcon,
  });

  if (isUsCurrentTalent) {
    items.push({
      text: 'FAQ for Talents',
      href: 'https://www.opentalent.co/opentalent-candidate-faq',
      Icon: FAQIcon,
    });
  }

  return items;
};
const useCompanyBottomDrawerItems = (): BottomDrawerListItemProps[] => {
  const isFreeCompanyAccount = useIsFreeCompanyAccount();
  const items: BottomDrawerListItemProps[] = [];
  const isUsCompany = useIsUsCompany();

  if (isFreeCompanyAccount) {
    items.push({
      text: 'Book a Demo',
      href: 'https://calendly.com/pieter-meeting/book-a-demo',
      Icon: CalendarIcon,
    });
  } else {
    if (!isUsCompany) {
      items.push({
        text: 'Contact Us',
        href: 'https://wa.me/message/VHHZBB7TCN52C1',
        Icon: WhatsAppIcon,
      });
    }
  }

  items.push({
    text: 'FAQ for Recruiter',
    href: 'https://www.opentalent.co/opentalent-faq-recruiters-company-users',
    Icon: FAQIcon,
  });

  items.push({
    text: 'Give Feedback',
    href: `https://form.typeform.com/to/${COMPANY_FORM_ID}`,
    Icon: LiveHelpOutlinedIcon,
  });
  return items;
};
